import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-CalendarShape",
  "use": "svg-icon-CalendarShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-CalendarShape\"><path clip-rule=\"evenodd\" d=\"M8 3H5v3h3zm4 0H9v3h3zm1 0h3v3h-3zm3 4h-3v3h3zM9 7h3v3H9zM8 7H5v3h3zM1 7h3v3H1zm3 4H1v3h3zm1 0h3v3H5zm7 0H9v3h3z\" fill=\"#000\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol